import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

const { notes } = routes;

/** The itinerary's notes and one item's notes are the same list, filtered by the route. */
export const notesRoutes: RouteRender[] = [
  lazyView(
    notes.list,
    () => import("./notes-list").then((m) => ({ default: m.NotesListPage })),
    () => i18n.t("notes.title"),
  ),
  lazyView(
    notes.item,
    () => import("./notes-list").then((m) => ({ default: m.NotesListPage })),
    () => i18n.t("notes.title"),
  ),
  lazyView(
    notes.edit,
    () => import("./note-edit").then((m) => ({ default: m.NoteEditPage })),
    () => i18n.t("notes.note"),
  ),
];
